// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__31aUq","range":"MonthRangeSwitch_range__cuqCS","disabled":"MonthRangeSwitch_disabled__GqE4z"};